
import React from 'react';
import CityMetauxPage from '@/components/valorisation/CityMetauxPage';

const AchatMetauxDecazeville = () => {
  return (
    <CityMetauxPage
      cityName="Decazeville"
      departmentName="Aveyron"
      departmentCode="12"
      region="Occitanie"
      description="Ancien bassin minier, Decazeville bénéficie de notre expertise spécialisée dans le rachat de métaux industriels et ferrailles lourdes issues du patrimoine minier."
      specialities={[
        "Ferraille lourde et métaux industriels",
        "Équipements miniers et patrimoine industriel",
        "Métaux de démolition industrielle",
        "Fonte et aciers spéciaux"
      ]}
      nearbyAreas={[
        "Aubin", "Cransac", "Firmi", "Livinhac-le-Haut", "Flagnac", "Boisse-Penchot"
      ]}
      heroImage="https://images.unsplash.com/photo-1605810230434-7631ac76ec81?w=1280&q=80"
    />
  );
};

export default AchatMetauxDecazeville;
